module.exports = __webpack_public_path__ + "img/b8bff540503a3dfd119f61e25bf67367.c7cb102e.png";